import { Box, Button, Container, Grid, Typography, Stack } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect } from "react";
import api from "../../../utils/api";

import useStressStore from "../../../store/stressStores";
import { useLocation, useNavigate } from "react-router-dom";
import tabbg from "../../../assets/images/tab_01.png"

import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];


const StressMain = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // getStressList();

    return () => {
      // storeData.clear();
    }
  }, [])

  function getStressList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}`)
      .then(res => {
        console.log(res);
        storeData.setStressList(res.data.data);
      })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>

      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '2rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
              한국인 직무 스트레스 측정도구<br/>(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
      <Box sx={{p: 2, boxSizing:"border-box", m: '50px 0px 10px 0px'}}>
        <Card sx={{ '& p': { lineHeight: 1.5, position:'relative', pl: '15px', mb: 2}, '& p:last-child': { pb: 0, mb: 0},'& p:before': {content: '"-"', position: "absolute", left: 0, top:'0'},  borderRadius:5, p: 1.5 }}>
          <CardContent>
            <Typography>KOSS는 산업안전보건연구원에서 근로자의 직무 스트레스 요인을 측정할 수 있도록 개발한 표준화된 도구입니다.</Typography>
            <Typography>측정도구는 모두 43개 문항으로 구성됩니다.</Typography>
            <Typography>측정하고자 하는 직무 스트레스 요인은 8개 영역으로 물리적 환경, 직무요구, 직무 자율성, 관계 갈등, 직무 불안정, 조직체계, 보상 부적절, 직장문화를 포함합니다.</Typography>
            <Typography>각 항목에 대한 느낌이나 생각이 가장 가까운 대답에 표시해 주세요.</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box sx={{ textAlign: 'center', p: 2 }}>
        <Button variant="contained" onClick={() => navigate('/survey/stress/answer', { state: location.state })} sx={{ background: '#EF8322', borderRadius: 20, p: 1, width: '100%',mb: 5, '&:hover': { background: '#EF8322' } }}>시작하기</Button>
      </Box>
      <Bottom />
    </Container>
  )
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default StressMain;